<template>
  <div class="d-flex align-center" style="gap: 1rem;" v-if="isSuperadmin">
    <div style="font-size: 14px">
      Alle abschliessen
    </div>
    <v-switch
        v-model="allCompleted"
        inset
        dense
    />
  </div>
</template>

<script>

import {internalOrderMixin} from "@/mixins/SmartLogistics/ModelC/internalOrder";
import {completeItemsMixin} from "@/mixins/SmartLogistics/ModelC/completeItems";

export default {
  name: 'OrderCompleteAllSwitch',
  mixins: [internalOrderMixin, completeItemsMixin],

  computed: {
    allCompleted: {
      get() {
        for(let i in this.currentlyOpenPartialDelivery.items) {
          let item = this.currentlyOpenPartialDelivery.items[i]

          if (item.orderedQuantity > item.deliveredBefore + item.quantity) {
            return false
          }
        }

        return true
      },
      set(value) {
        if(value) {
          this.completeItems(this.currentlyOpenPartialDelivery.items)
        } else {
          this.resetItems(this.currentlyOpenPartialDelivery.items)
        }
      }
    },

    isSuperadmin() {
      return this.$store.state.benutzer.info.superadmin === 1
    },
  }
}

</script>